import equals from 'fast-deep-equal';
import { has, allPass, propEq, complement, cond, T, always, map, path, head, defaultTo, tail, split, pathOr, last, reduce, addIndex, merge, assoc, prop, reduceWhile, isNil, mergeAll, compose, length, append, keys, difference, flatten, not, equals as equals$1, takeLast, curry, isEmpty, lens, propOr, assocPath, lensProp, pipe, unless, is, of, reject, dissoc, converge, identity, pathEq, concat, reduceBy, dissocPath, uniq, any, when, filter, values, all, over, mapObjIndexed, contains, juxt } from 'ramda';
import { createSelector } from 'reselect';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { setPropTypes, fromRenderProps } from 'recompose';
import { connect } from 'react-redux';
import kebabCase from 'lodash.kebabcase';
import { Space, FlexItem, Flex } from '@rushplay/common';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var MissingRefError =
/*#__PURE__*/
function (_Error) {
  _inherits(MissingRefError, _Error);

  function MissingRefError(message) {
    var _this;

    _classCallCheck(this, MissingRefError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MissingRefError).call(this, message));
    _this.name = 'MissingRefError';
    return _this;
  }

  return MissingRefError;
}(_wrapNativeSuper(Error));

function F() {
  return false;
}

function identity$1(x) {
  return x;
}

function not$1(x) {
  return !x;
}

function _reduce(halt, fn, y, xs) {
  var result = y;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = xs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var x = _step.value;

      if (halt(result)) {
        return result;
      }

      result = fn(result, x);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return result;
}

function all$1(fn, xs) {
  return _reduce(not$1, function (_, x) {
    return fn(x);
  }, true, xs);
}
function any$1(fn, xs) {
  return _reduce(identity$1, function (_, x) {
    return fn(x);
  }, false, xs);
}
function map$1(fn, xs) {
  return reduce$1(function (ys, x) {
    return ys.concat([fn(x)]);
  }, [], xs);
}
function reduce$1(fn, y, xs) {
  return _reduce(F, fn, y, xs);
}
function get(fallback, path$$1, obj) {
  return _reduce(function (result) {
    return result == null;
  }, function (result, key) {
    return result.hasOwnProperty(key) ? result[key] : fallback;
  }, obj, path$$1);
} // Get value at path with $ref awareness

function getResolved(fallback, path$$1, obj) {
  return _reduce(function (result) {
    return result == null;
  }, function (result, key) {
    if (fallback instanceof Error) {
      if (!result.hasOwnProperty(key)) {
        throw fallback;
      }
    }

    var nextResult = result.hasOwnProperty(key) ? result[key] : fallback;

    if (nextResult == null) {
      return nextResult;
    }

    if (!nextResult.hasOwnProperty('$ref')) {
      return nextResult;
    }

    var ref = nextResult.$ref;
    var error = new MissingRefError("\"".concat(ref, "\" is missing in root schema"));
    var refPath = ref.split('/').slice(1);
    return getResolved(error, refPath, obj);
  }, obj, path$$1);
}
function reject$1(fn, xs) {
  return reduce$1(function (ys, x) {
    return fn(x) ? ys : ys.concat([x]);
  }, [], xs);
}
function isEmptyArray(xs) {
  return xs.length === 0;
}
function unnest(xs) {
  return reduce$1(function (ys, x) {
    return ys.concat(Array.isArray(x) ? x : [x]);
  }, [], xs);
}

function exclusiveMaximum(reference, data) {
  if (reference == null) {
    return true;
  }

  return data < reference;
}
function exclusiveMinimum(reference, data) {
  if (reference == null) {
    return true;
  }

  return data > reference;
}
function maximum(reference, data) {
  if (reference == null) {
    return true;
  }

  return data <= reference;
}
function minimum(reference, data) {
  if (reference == null) {
    return true;
  }

  return data >= reference;
}
function multipleOf(reference, data) {
  if (reference == null) {
    return true;
  }

  return data % reference === 0;
}
function maxLength(reference, data) {
  if (reference == null) {
    return true;
  }

  return data.length <= reference;
}
function maxProperties(reference, data) {
  return maxLength(reference, Object.keys(data));
}
function minLength(reference, data) {
  if (reference == null) {
    return true;
  }

  return data.length >= reference;
}
function minProperties(reference, data) {
  return minLength(reference, Object.keys(data));
}
function pattern(reference, data) {
  if (reference == null) {
    return true;
  }

  var re = new RegExp(reference);
  return re.test(data);
}
function required(reference, data) {
  if (reference == null) {
    return true;
  }

  return all$1(function (key) {
    return data.hasOwnProperty(key);
  }, reference);
}
function type(reference, data) {
  if (reference == null) {
    return true;
  }

  switch (reference) {
    case 'null':
      {
        return data === null;
      }

    case 'boolean':
    case 'number':
    case 'string':
      {
        return _typeof(data) === reference;
      }

    case 'integer':
      {
        return parseInt(data, 10) === data;
      }

    case 'array':
      {
        return Array.isArray(data);
      }

    case 'object':
      {
        return data != null && _typeof(data) === 'object' && Array.isArray(data) === false;
      }

    default:
      {
        throw new Error("Unknown type \"".concat(reference, "\""));
      }
  }
}
function uniqueItems(reference, data) {
  if (reference == null) {
    return true;
  }

  if (reference) {
    for (var i = data.length - 1; i >= 0; i--) {
      var index = data.indexOf(data[i]);

      if (index > -1 && index < i) {
        return false;
      }
    }
  }

  return true;
}
function values$1(reference, data) {
  if (reference == null) {
    return true;
  }

  return any$1(function (x) {
    return equals(data, x);
  }, reference);
}
function value(reference, data) {
  if (reference == null) {
    return true;
  }

  return values$1([reference], data);
}

var checks = /*#__PURE__*/Object.freeze({
  exclusiveMaximum: exclusiveMaximum,
  exclusiveMinimum: exclusiveMinimum,
  maximum: maximum,
  minimum: minimum,
  multipleOf: multipleOf,
  maxLength: maxLength,
  maxProperties: maxProperties,
  minLength: minLength,
  minProperties: minProperties,
  pattern: pattern,
  required: required,
  type: type,
  uniqueItems: uniqueItems,
  values: values$1,
  value: value
});

var VALIDATORS_MAPPING = {
  "const": 'value',
  "enum": 'values',
  maxItems: 'maxLength',
  minItems: 'minLength'
  /**
   * Validate JSON instance using given JSON schema
   * @param {Array.<string>} absoluteInstancePath
   * @param {Array.<string>} absoluteSchemaPath
   * @param {*} instance
   * @param {Object.<string, *>} schema
   * @param {function(ValidationError): undefined} onError
   * @returns {undefined}
   */

};

function validate(absoluteInstancePath, absoluteSchemaPath, instance, schema, onError) {
  function createError(validator, validatorValue, context) {
    return {
      absoluteInstancePath: absoluteInstancePath,
      absoluteSchemaPath: absoluteSchemaPath.concat([validator]),
      context: context,
      validator: validator,
      validatorValue: validatorValue
    };
  }

  if (schema == null) {
    return null;
  }

  var schemaSlice = getResolved(undefined, absoluteSchemaPath, schema);

  if (schemaSlice == null) {
    return null;
  }

  var instanceSlice = get(undefined, absoluteInstancePath, instance);

  for (var validator in schemaSlice) {
    var validatorValue = schemaSlice[validator];

    switch (validator) {
      case 'additionalItems':
        {
          if (Array.isArray(schemaSlice.items)) {
            var start = schemaSlice.items.length;
            var end = instanceSlice.length;

            for (var index = start; index < end; index++) {
              validate(absoluteInstancePath.concat([index]), absoluteSchemaPath.concat([validator, index]), instance, schema, onError);
            }
          }

          break;
        }

      case 'additionalProperties':
        {
          var instanceProperties = Object.keys(instanceSlice);
          var properties = get({}, ['properties'], schemaSlice);
          var patterns = map$1(function (pattern) {
            return new RegExp(pattern);
          }, Object.keys(get({}, ['patternProperties'], schemaSlice)));

          var _loop = function _loop() {
            var key = _instanceProperties[_i];

            if (!properties.hasOwnProperty(key) && !any$1(function (re) {
              return re.test(key);
            }, patterns)) {
              validate(absoluteInstancePath.concat([key]), absoluteSchemaPath.concat([validator]), instance, schema, onError);
            }
          };

          for (var _i = 0, _instanceProperties = instanceProperties; _i < _instanceProperties.length; _i++) {
            _loop();
          }

          break;
        }

      case 'allOf':
      case 'anyOf':
      case 'oneOf':
        {
          if (Array.isArray(validatorValue)) {
            var validations = [];

            var _loop2 = function _loop2(_index) {
              var errors = [];
              validate(absoluteInstancePath, absoluteSchemaPath.concat([validator, _index]), instance, schema, function (error) {
                return errors.push(error);
              });
              validations.push(errors);
            };

            for (var _index in validatorValue) {
              _loop2(_index);
            }

            var failedCount = reject$1(isEmptyArray, validations).length;
            var passedCount = validatorValue.length - failedCount;

            if (validator === 'allOf' && failedCount > 0 || validator === 'anyOf' && passedCount < 1 || validator === 'oneOf' && passedCount !== 1) {
              onError(createError(validator, validatorValue, unnest(validations)));
            }
          }

          break;
        }

      case 'contains':
        {
          var _ret = function () {
            var context = [];

            var _loop3 = function _loop3(_index2) {
              var errors = [];
              validate(absoluteInstancePath.concat([_index2]), absoluteSchemaPath.concat([validator]), instance, schema, function (error) {
                context.push(error);
                errors.push(error);
              }); // Stop and succeed if any instance item passes validation

              if (errors.length === 0) {
                context.length = 0;
                return "break";
              }
            };

            for (var _index2 in instanceSlice) {
              var _ret2 = _loop3(_index2);

              if (_ret2 === "break") break;
            }

            if (instanceSlice.length === 0 || context.length) {
              onError(createError(validator, validatorValue, context));
            }

            return "break";
          }();

          break;
        }

      case 'dependencies':
        {
          for (var dependency in validatorValue) {
            if (instanceSlice.hasOwnProperty(dependency)) {
              if (Array.isArray(validatorValue[dependency])) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                  for (var _iterator = validatorValue[dependency][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var property = _step.value;

                    if (!instanceSlice.hasOwnProperty(property)) {
                      onError(createError(validator, validatorValue));
                    }
                  }
                } catch (err) {
                  _didIteratorError = true;
                  _iteratorError = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion && _iterator["return"] != null) {
                      _iterator["return"]();
                    }
                  } finally {
                    if (_didIteratorError) {
                      throw _iteratorError;
                    }
                  }
                }
              } else {
                validate(absoluteInstancePath, absoluteSchemaPath.concat([validator, dependency]), instance, schema, onError);
              }
            }
          }

          break;
        }

      case 'if':
        {
          var valid = true;
          validate(absoluteInstancePath, absoluteSchemaPath.concat(['if']), instance, schema, function () {
            valid = false;
          });
          var conditionalValidator = valid ? 'then' : 'else';
          validate(absoluteInstancePath, absoluteSchemaPath.concat([conditionalValidator]), instance, schema, onError);
          break;
        }

      case 'items':
        {
          if (Array.isArray(schemaSlice.items)) {
            for (var _index3 in validatorValue) {
              validate(absoluteInstancePath.concat([_index3]), absoluteSchemaPath.concat([validator, _index3]), instance, schema, onError);
            }
          } else {
            for (var _index4 in instanceSlice) {
              validate(absoluteInstancePath.concat([_index4]), absoluteSchemaPath.concat([validator]), instance, schema, onError);
            }
          }

          break;
        }

      case 'not':
        {
          var _validateSchema = validateSchema(validatorValue, instanceSlice),
              _valid = _validateSchema.valid;

          if (_valid) {
            onError(createError(validator, validatorValue));
          }

          break;
        }

      case 'patternProperties':
        {
          var _loop4 = function _loop4(pattern) {
            var re = new RegExp(pattern);
            var properties = Object.keys(instanceSlice).filter(function (key) {
              return re.test(key);
            });
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = properties[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var key = _step2.value;
                validate(absoluteInstancePath.concat([key]), absoluteSchemaPath.concat([validator, pattern]), instance, schema, onError);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2["return"] != null) {
                  _iterator2["return"]();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          };

          for (var pattern in validatorValue) {
            _loop4(pattern);
          }

          break;
        }

      case 'properties':
        {
          for (var key in instanceSlice) {
            validate(absoluteInstancePath.concat([key]), absoluteSchemaPath.concat([validator, key]), instance, schema, onError);
          }

          break;
        }

      default:
        {
          var check = VALIDATORS_MAPPING[validator] || validator;
          var fn = checks[check];

          if (fn && !fn(validatorValue, instanceSlice)) {
            onError(createError(validator, validatorValue));
          }

          break;
        }
    }
  }
}

function validateSchema(schema, instance) {
  var errors = [];
  validate([], [], instance, schema, function (error) {
    return errors.push(error);
  });
  return {
    valid: errors.length === 0,
    errors: errors
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var lensPropOr = function lensPropOr(fallback, name) {
  return lens(propOr(fallback, name), assoc(name));
};

var lensPathOr = function lensPathOr(fallback, path$$1) {
  return lens(pathOr(fallback, path$$1), assocPath(path$$1));
};

var fieldLens = function fieldLens(form, field) {
  return compose(formLens(form), lensPathOr({}, ['fields', field]));
};

var formLens = function formLens(form) {
  return compose(lensProp('data'), lensPropOr({}, form));
};

var formFieldsLens = function formFieldsLens(form) {
  return compose(formLens(form), lensPropOr({}, 'fields'));
};

var errorsAsArray = pipe(unless(is(Array), of), reject(isNil));

/**
 * Reset field state
 * @param {object} Field state
 * @returns {object}
 */
var resetField = pipe(dissoc('status'), dissoc('value'), dissoc('visited'));

/**
 * Reset field errors
 * @param {object} Field state
 * @returns {object}
 */
var resetFieldErrors = pipe(assoc('status', 'valid'), assoc('errors', []));

/**
 * Commit field state
 * @param {object} Field state
 * @returns {object}
 */
var commitField = pipe(converge(assoc('initialValue'), [prop('value'), identity]), dissoc('status'), dissoc('visited'));

function getValidatorValues(fields) {
  return reduce(function (errors, error) {
    if (not(pathEq(['value'], undefined, fields[error]))) {
      return merge(errors, defineProperty({}, error, path([error, 'value'], fields)));
    }

    if (not(pathEq(['initialValue'], undefined, fields[error]))) {
      return merge(errors, defineProperty({}, error, path([error, 'initialValue'], fields)));
    }

    return errors;
  }, {}, keys(fields));
}

/**
 * FieldError.
 * @typedef {Object} FieldError
 * @property {string} field Field name
 * @property {string} translationKey Translation key
 * @property {object} variables Translation variables
 */

/**
 * FormValidation.
 * @typedef {Object} FormValidation
 * @property {("valid"|"invalid")} status
 * @property {Object.<FieldError>} errors Field errors indexed by field name
 */

/**
 * Validates form.
 * @param {string} form Form name
 * @param {*} schema Data schema
 * @param {*} fields Form fields
 * @returns {FormValidation}
 */
function validateForm(form, schema, fields) {
  var result = validateSchema(schema, getValidatorValues(fields));
  var status = result.valid ? 'valid' : 'invalid';

  var reducedErrors = reduce(function (acc, data) {
    var context = path(['context'], data);

    if (length(path(['absoluteInstancePath'], data))) {
      return concat(acc, [data]);
    }

    if (context) {
      return concat(acc, context);
    }

    return acc;
  }, [], result.errors);

  var errors = map(function (error) {
    var field = last(path(['absoluteInstancePath'], error));

    var fieldError = {
      field: field,
      variables: defineProperty({}, error.validator, error.validatorValue),
      translationKey: null
    };

    if (field) {
      if (error.validator === 'minLength' && error.validatorValue === 1) {
        return assoc('translationKey', form + '.' + field + '.errors.required', fieldError);
      }

      return assoc('translationKey', form + '.' + field + '.errors.' + error.validator, fieldError);
    }
  }, reducedErrors);

  return {
    status: status,
    errors: reduceBy(function (fieldErrors, fieldError) {
      return fieldErrors.concat(dissocPath(['field'], fieldError));
    }, [], path(['field']), reject(isNil, uniq(errors)))
  };
}

var BLURED = 'forms/BLURED';
var FIELDS_CLEARED = 'forms/FIELDS_CLEARED';
var FIELD_ERROR_RESET = 'forms/FIELD_ERROR_RESET';
var FIELD_DESTROYED = 'forms/FIELD_DESTROYED';
var FOCUSED = 'forms/FOCUSED';
var FORM_CLEARED = 'forms/FORM_CLEARED';
var FORM_COMMITTED = 'forms/FORM_COMMITTED';
var FORM_DESTROYED = 'forms/FORM_DESTROYED';
var FORM_VALIDATED = 'forms/FORM_VALIDATED';
var FORMS_DESTROYED = 'forms/FORMS_DESTROYED';
var REGISTERED = 'forms/REGISTERED';
var VALIDATED = 'forms/VALIDATED';
var VALUE_CHANGED = 'forms/VALUE_CHANGED';
var VISITED = 'forms/VISITED';

/**
 * Remove focus property on field
 * @param {string} form
 * @param {string} field
 * @returns {object}
 */
function blur(form, field) {
  return {
    type: BLURED,
    payload: { form: form, field: field }
  };
}

/**
 * Reset field errors
 * @param {string} form
 * @param {string[]} fields
 * @returns {object}
 */
function resetFieldErrors$1(form, field) {
  return {
    type: FIELD_ERROR_RESET,
    payload: { form: form, field: field }
  };
}

/**
 * Clear values of specified fields
 * @param {string} form
 * @param {string[]} fields
 * @returns {object}
 */
function clearFields(form, fields) {
  return {
    type: FIELDS_CLEARED,
    payload: { form: form, fields: fields }
  };
}

/**
 * Remove specified field
 * @param {string} form
 * @param {Array.<String>} field
 * @returns {Object} Redux action
 */
function destroyField(form, field) {
  return {
    type: FIELD_DESTROYED,
    payload: { form: form, field: field }
  };
}

/**
 * Clear all values of specified form
 * @param {string} form
 * @returns {string}
 */
function clearForm(form) {
  return {
    type: FORM_CLEARED,
    payload: form
  };
}

/**
 * Clear all values of all forms
 */
function clearForms() {
  return {
    type: FORMS_DESTROYED
  };
}

/**
 * Turn field values into initial values
 * @param {string} form
 * @returns {string}
 */
function commitForm(form) {
  return {
    type: FORM_COMMITTED,
    payload: form
  };
}

/**
 * Remove specified form
 * @param {string} form
 * @returns {string}
 */
function destroyForm(form) {
  return {
    type: FORM_DESTROYED,
    payload: form
  };
}

/**
 * Add focused property to field
 * @param {string} form
 * @param {string} field
 * @returns {object}
 */
function focus(form, field) {
  return {
    type: FOCUSED,
    payload: { form: form, field: field }
  };
}

/**
 * Validate the form and set errors
 * @param {string} form
 * @param {object} [options]
 * @param {string} [options.status] Form validation status
 * @param {string[]} [options.errors] Validation errors
 * @returns {object}
 */
function validateForm$1(form, options) {
  return {
    type: FORM_VALIDATED,
    payload: {
      form: form,
      status: options.status,
      errors: errorsAsArray(options.errors)
    }
  };
}

/**
 * Change value of field
 * @param {string} form
 * @param {string} field
 * @param {*} value
 * @returns {object}
 */
function changeValue(form, field, value) {
  return {
    type: VALUE_CHANGED,
    payload: {
      form: form,
      field: field,
      value: value
    }
  };
}

/**
 * Add form, field and options for the form
 * @param {string} form
 * @param {string} field
 * @param {object} [options]
 * @param {string} [options.group] Field's group
 * @param {*} [options.initialValue] Add initial value
 * @param {*} [options.value] Set value
 * @returns {object}
 */
function register(form, field, options) {
  return {
    type: REGISTERED,
    payload: {
      field: field,
      form: form,
      initialValue: options && options.initialValue,
      group: options && options.group,
      value: options && options.value
    }
  };
}

/**
 * Validate the field and set errors
 * @param {string} form
 * @param {string} field
 * @param {object} [options]
 * @param {string} [options.status] Field validation status
 * @param {*} [options.value] Field value to be validated
 * @param {string[]} [options.errors] Validation errors
 * @param {object} [options.variables] Validation values
 * @returns {object}
 */
function validate$1(form, field, options) {
  return {
    type: VALIDATED,
    payload: {
      field: field,
      form: form,
      value: options.value,
      errors: errorsAsArray(options.errors),
      status: options.status,
      variables: options.variables
    }
  };
}

/**
 * Mark field as visited
 * @param {string} form
 * @param {string} field
 * @returns {object}
 */
function visit(form, field) {
  return {
    type: VISITED,
    payload: { field: field, form: form }
  };
}

function getForm(state, props) {
  return path(['data', props.form], state);
}

function getField(state, props) {
  return path([props.field], state);
}

var getFormFields = createSelector([getForm, function (state, props) {
  return props;
}], function (state, props) {
  return pipe(path(['fields']), when(function () {
    return props.group;
  }, filter(propEq('group', props.group))))(state);
});

var getFormField = createSelector([getFormFields, function (state, props) {
  return props.field;
}], function (fields, field) {
  return path([field], fields);
});

var isFieldPristine = createSelector([getField], converge(equals$1, [path(['initialValue']), path(['value'])]));

/**
 * Check validation status of all form fields; returns true if all fields has specified status, false otherwise
 * @param {object} state
 * @param {object} props
 * @param {string} props.form form
 * @param {string} props.field field
 * @param {string} props.status validation status to compare field statuses with
 * @returns {boolean}
 */
var isAllFieldsHaveStatus = createSelector([getFormFields, function (state, props) {
  return props;
}], function (state, props) {
  return pipe(values, all(propEq('status', props.status)))(state);
});

/**
 * Check if field is focused
 * @param {object} state
 * @param {object} props
 * @param {string} props.form form
 * @param {string} props.field field
 * @returns {boolean}
 */
var isFocused = createSelector([path(['focused']), function (state, props) {
  return props;
}], equals$1);

/**
 * Check if field’s value was edited
 * @param {object} state
 * @param {object} props
 * @param {string} props.form form
 * @param {string} props.field field
 * @returns {boolean}
 */
var isPristine = createSelector([getFormFields, function (state, props) {
  return props;
}], function (state, props) {
  return isFieldPristine(state, props);
});

/**
 * Get the value of whether the form's field is valid
 * @param {object} state
 * @param {object} props
 * @param {string} props.form form
 * @param {string} props.field field
 * @returns {boolean}
 */

var isValid = createSelector([getFormField], pathEq(['status'], 'valid'));

/**
 * Get the value of whether the field has been visited
 * @param {object} state
 * @param {object} props
 * @param {string} props.form form
 * @param {string} props.field field
 * @returns {boolean}
 */
var isVisited = createSelector([getFormField], pathEq(['visited'], true));

/**
 * Get the errors of the form's field
 * @param {object} state
 * @param {object} props
 * @param {string} props.form form
 * @param {string} props.field field
 * @returns {array}
 */
var errors = createSelector([getFormField], path(['errors']));

/**
 * Get the field's object of the form
 * @param {object} state
 * @param {object} props
 * @param {string} props.form form
 * @returns {object}
 */
var fields = createSelector([getForm], path(['fields']));

/**
 * Get the errors of the form
 * @param {object} state
 * @param {object} props
 * @param {string} props.form form
 * @returns {array}
 */
var formErrors = createSelector([getForm], path(['errors']));

/**
 * Get the status of the form's field
 * @param {object} state
 * @param {object} props
 * @param {string} props.form form
 * @param {string} props.field field
 * @returns {array}
 */
var status = createSelector([getFormField], path(['status']));

/**
 * Get the value of the form's field
 * @param {object} state
 * @param {object} props
 * @param {string} props.form form
 * @param {string} props.field field
 * @returns {*}
 */
var value$1 = createSelector([getFormField], path(['value']));

/**
 *  Check if given form field is registrered
 * @param {object} state
 * @param {string} form Form name
 * @param {string} field Field name
 * @returns {Boolean} true if field is registrered else false
 */
var isFieldRegistered = function isFieldRegistered(state, form, field) {
  return form && field ? getFormField(state, {
    form: form,
    field: field
  }) : false;
};

var FormContext = React.createContext();

var Form = function (_React$Component) {
  inherits(Form, _React$Component);

  function Form() {
    classCallCheck(this, Form);
    return possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).apply(this, arguments));
  }

  createClass(Form, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onDestroy();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.dataSchema && not(equals$1(this.props.fields, prevProps.fields))) {
        this.props.onValidateForm(this.props.fields);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'form',
        {
          className: this.props.className,
          onSubmit: function onSubmit(event) {
            event.preventDefault();
            _this2.props.onSubmit(_this2.props.fields);
          }
        },
        React.createElement(
          FormContext.Provider,
          { value: this.props },
          this.props.children({
            dataSchema: this.props.dataSchema,
            errors: this.props.errors,
            fields: this.props.fields,
            name: this.props.name,
            valid: this.props.valid,
            onSubmit: function onSubmit() {
              return _this2.props.onSubmit(_this2.props.fields);
            }
          })
        )
      );
    }
  }]);
  return Form;
}(React.Component);

Form.defaultProps = {
  onSubmit: function onSubmit() {}
};

Form.propTypes = {
  className: PropTypes.string,
  children: PropTypes.func.isRequired,
  errors: PropTypes.arrayOf(PropTypes.string),
  fields: PropTypes.objectOf(PropTypes.object),
  name: PropTypes.string,
  valid: PropTypes.bool,
  dataSchema: PropTypes.object,
  onValidateForm: PropTypes.func,
  onDestroy: PropTypes.func,
  onSubmit: PropTypes.func.isRequired
};

function combineHandlers(handler, extension) {
  if (extension) {
    return juxt([handler, extension]);
  }

  return handler;
}

var deepEqual = require('fast-deep-equal');

var Field = function (_React$PureComponent) {
  inherits(Field, _React$PureComponent);

  function Field() {
    classCallCheck(this, Field);

    var _this = possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this));

    _this.getProps = _this.getProps.bind(_this);
    _this.handleBlur = _this.handleBlur.bind(_this);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleFocus = _this.handleFocus.bind(_this);
    _this.handleRegister = _this.handleRegister.bind(_this);
    _this.handleValidate = _this.handleValidate.bind(_this);
    return _this;
  }

  createClass(Field, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handleRegister();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (any(is(Array), [prevProps.initialValue, this.props.initialValue])) {
        if (!deepEqual(prevProps.initialValue, this.props.initialValue)) {
          this.handleRegister();
        }

        if (!deepEqual(prevProps.value, this.props.value)) {
          this.handleValidate();
        }

        return;
      }

      if (prevProps.initialValue !== this.props.initialValue) {
        this.handleRegister();
      }

      if (not(equals$1(prevProps.value, this.props.value))) {
        this.handleValidate();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (not(this.props.keepOnUnmount)) {
        this.props.onFieldDestroy();
      }
    }
  }, {
    key: 'getProps',
    value: function getProps(extraProps) {
      return {
        disabled: this.props.disabled,
        errors: this.props.errors,
        focused: this.props.focused,
        format: this.props.format,
        initialValue: this.props.initialValue,
        name: this.props.name,
        normalize: this.props.normalize,
        parentName: this.props.form,
        pristine: this.props.pristine,
        status: this.props.status,
        validator: this.props.validator,
        value: this.props.parse(this.props.value),
        visited: this.props.visited,
        onBlur: combineHandlers(this.handleBlur, extraProps && extraProps.onBlur),
        onChange: combineHandlers(this.handleChange, extraProps && extraProps.onChange),
        onFocus: combineHandlers(this.handleFocus, extraProps && extraProps.onFocus)
      };
    }
  }, {
    key: 'getStateAndHelpers',
    value: function getStateAndHelpers() {
      return merge(this.getProps(), {
        getProps: this.getProps
      });
    }
  }, {
    key: 'handleBlur',
    value: function handleBlur(event) {
      this.props.onBlur(event);
    }
  }, {
    key: 'handleFocus',
    value: function handleFocus(event) {
      this.props.onFocus(event);
    }
  }, {
    key: 'handleChange',
    value: function handleChange(event) {
      var value = defaultTo(event, path(['target', 'value'], event));
      var normalizedValue = this.props.normalize(value);

      this.props.onChange(normalizedValue);
    }
  }, {
    key: 'handleRegister',
    value: function handleRegister() {
      this.props.onFieldRegister(this.props.initialValue, this.props.value);
    }
  }, {
    key: 'handleValidate',
    value: function handleValidate() {
      this.props.onValidate(this.props.normalize(this.props.value));
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children(this.getStateAndHelpers());
    }
  }]);
  return Field;
}(React.PureComponent);

Field.defaultProps = {
  normalize: identity,
  parse: identity
};

Field.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.func]),
  disabled: PropTypes.bool,
  errors: PropTypes.array,
  focused: PropTypes.bool,
  form: PropTypes.string,
  format: PropTypes.string,
  initialValue: PropTypes.any,
  keepOnUnmount: PropTypes.bool,
  name: PropTypes.string.isRequired,
  normalize: PropTypes.func,
  parse: PropTypes.func,
  pristine: PropTypes.bool.isRequired,
  status: PropTypes.string,
  validator: PropTypes.array,
  value: PropTypes.any,
  visited: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onFieldDestroy: PropTypes.func.isRequired,
  onFieldRegister: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired
};

function mapStateToProps(state, props) {
  var formsState = prop(props.mountPoint, state);

  var pointer = {
    form: props.form,
    field: props.name
  };

  return {
    errors: errors(formsState, pointer),
    focused: isFocused(formsState, pointer),
    pristine: isPristine(formsState, pointer),
    status: status(formsState, pointer),
    valid: isValid(formsState, pointer),
    value: value$1(formsState, pointer),
    visited: isVisited(formsState, pointer)
  };
}

function mapDispatchToProps(dispatch, props) {
  return {
    onBlur: function onBlur() {
      dispatch(blur(props.form, props.name));
      dispatch(visit(props.form, props.name));
    },
    onChange: function onChange(value) {
      dispatch(changeValue(props.form, props.name, value));
    },
    onFieldDestroy: function onFieldDestroy() {
      return dispatch(destroyField(props.form, props.name));
    },
    onFieldRegister: function onFieldRegister(initialValue, value) {
      dispatch(register(props.form, props.name, {
        group: props.group,
        initialValue: initialValue,
        value: value
      }));
    },
    onFocus: function onFocus() {
      return dispatch(focus(props.form, props.name));
    },
    onValidate: function onValidate(value) {
      dispatch(validate$1(props.form, props.name, { status: 'processing' }));
      if (props.validator) {
        var validateAction = reduceWhile(isNil, function (action, validator) {
          return validator(props.form, props.name, value);
        }, undefined, props.validator);

        if (validateAction) {
          return dispatch(validateAction);
        }
      }

      dispatch(validate$1(props.form, props.name, { status: 'valid' }));
    }
  };
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return mergeAll([ownProps, stateProps, dispatchProps, {
    onFieldRegister: function onFieldRegister() {
      return dispatchProps.onFieldRegister(ownProps.initialValue, ownProps.value);
    }
  }]);
}

var connector = compose(setPropTypes({
  mountPoint: PropTypes.string.isRequired
}), fromRenderProps(FormContext.Consumer, function (context) {
  return {
    form: context.name
  };
}), connect(mapStateToProps, mapDispatchToProps, mergeProps));

var connector$1 = connector(Field);

function mapStateToProps$1(state, props) {
  var formsState = prop(props.mountPoint, state);

  return {
    errors: formErrors(formsState, { form: props.name }),
    fields: fields(formsState, { form: props.name }),
    valid: isAllFieldsHaveStatus(formsState, {
      form: props.name,
      status: 'valid'
    })
  };
}

function mapDispatchToProps$1(dispatch, props) {
  return {
    onDestroy: function onDestroy() {
      return dispatch(destroyForm(props.form));
    },
    onValidateForm: function onValidateForm(fields$$1) {
      var validation = validateForm(props.name, props.dataSchema, fields$$1);

      var prevFieldsWithErrors = reduce(function (acc, field) {
        if (path(['errors'], fields$$1[field])) {
          if (length(fields$$1[field].errors) > 0) {
            return append(field, acc);
          }
        }
        return acc;
      }, [], keys(fields$$1));
      var nextFieldsWithErrors = keys('field', validation.errors);

      var diff = difference(prevFieldsWithErrors, nextFieldsWithErrors);

      return dispatch(flatten([map(function (field) {
        return resetFieldErrors$1(props.name, field);
      }, diff), map(function (field) {
        return validate$1(props.name, field, {
          status: validation.status,
          errors: validation.errors[field]
        });
      }, keys(validation.errors)), validateForm$1(props.name, { status: validation.status })]));
    }
  };
}

var Form$1 = compose(setPropTypes({
  mountPoint: PropTypes.string.isRequired
}), connect(mapStateToProps$1, mapDispatchToProps$1))(Form);

/**
 * Get translation key corresponding to given form, field and error type
 * @param {string} form
 * @param {string} field
 * @param {string} error
 * @returns {string}
 */
var errorKey = function errorKey(form, field, error) {
  return form + "." + field + ".errors." + error;
};

/**
 * Tests value against expression and returns status
 * @param {string} expression regex to use in test
 * @param {string} form form
 * @param {string} field field
 * @param {string} value value to test expression against
 * @returns {object}
 */
var matchesRegex = curry(function (expression, form, field, value) {
  if (!expression.test(value)) {
    return validate$1(form, field, {
      errors: [{ translationKey: errorKey(form, field, 'invalid') }],
      status: 'invalid',
      value: value
    });
  }
});

/**
 * Validates values length against passed length and returns status
 * @param {number} length length to use in validation
 * @param {string} form form
 * @param {string} field field
 * @param {number} value value from which the length will be validated
 * @returns {object}
 */
var length$1 = curry(function (length$$1, form, field, value) {
  if (value && value.length !== length$$1) {
    return validate$1(form, field, {
      errors: [{ translationKey: errorKey(form, field, 'incorrect-length') }],
      status: 'invalid',
      value: value
    });
  }
});

/**
 * Parses and validates values length against passed max length and returns status
 * @param {number} max length to use in validation
 * @param {string} form form
 * @param {string} field field
 * @param {number} value value from which the length will be validated
 * @returns {object}
 */
var max = curry(function (max, form, field, value) {
  var val = parseFloat(value);

  if (!isNaN(val) && value > max) {
    return validate$1(form, field, {
      errors: [{ translationKey: errorKey(form, field, 'too-large') }],
      status: 'invalid',
      value: value
    });
  }
});

/**
 * Parses and validates values length against passed min length and returns status
 * @param {number} min length to use in validation
 * @param {string} form form
 * @param {string} field field
 * @param {number} value value from which the length will be validated
 * @returns {object}
 */
var min = curry(function (min, form, field, value) {
  var val = parseFloat(value);

  if (!isNaN(val) && value < min) {
    return validate$1(form, field, {
      errors: [{ translationKey: errorKey(form, field, 'too-small') }],
      status: 'invalid',
      value: value
    });
  }
});

/**
 * Validates values length against passed max length and returns status
 * @param {number} max length to use in validation
 * @param {string} form form
 * @param {string} field field
 * @param {number} value value from which the length will be validated
 * @returns {object}
 */
var maxLength$1 = curry(function (maxLength, form, field, value) {
  if (value && value.length > maxLength) {
    return validate$1(form, field, {
      errors: [{ translationKey: errorKey(form, field, 'too-long') }],
      status: 'invalid',
      value: value
    });
  }
});

/**
 * Validates values length against passed min length and returns status
 * @param {number} min length to use in validation
 * @param {string} form form
 * @param {string} field field
 * @param {number} value value from which the length will be validated
 * @returns {object}
 */
var minLength$1 = curry(function (minLength, form, field, value) {
  if (value && value.length < minLength) {
    return validate$1(form, field, {
      errors: [{ translationKey: errorKey(form, field, 'too-short') }],
      status: 'invalid',
      value: value
    });
  }
});

/**
 * Validates that value has been passed
 * @param {string} form form
 * @param {string} field field
 * @param {string|Array} value value that is required
 * @returns {object}
 */
function required$1(form, field, value) {
  if (isNil(value) || isEmpty(value) || Number.isNaN(value)) {
    return validate$1(form, field, {
      errors: [{ translationKey: errorKey(form, field, 'required') }],
      status: 'invalid',
      value: value
    });
  }
}

var isOptionField = has('enum');
var isItemsField = has('items');

var isSelectField = allPass([isOptionField, propEq('type', 'string')]);
var isCheckboxGroup = allPass([isItemsField, propEq('type', 'array')]);
var isTextField = allPass([complement(isOptionField), propEq('type', 'string')]);
var isNumberField = allPass([complement(isOptionField), propEq('type', 'number')]);

function getField$1(fieldData, components) {
  return cond([[isSelectField, function () {
    return components['singleSelectField'];
  }], [isCheckboxGroup, function () {
    return components['multipleSelectField'];
  }], [isTextField, function () {
    return components['textField'];
  }], [isNumberField, function () {
    return components['numberField'];
  }], [T, always(null)]])(fieldData);
}

function getOptions(fieldData, form, key) {
  if (isSelectField(fieldData)) {
    return map(function (value) {
      return {
        value: value,
        label: form.name + '.' + kebabCase(key) + '.' + kebabCase(value)
      };
    }, fieldData.enum);
  }

  if (isCheckboxGroup(fieldData)) {
    return map(function (value) {
      return {
        value: value,
        label: form.name + '.' + kebabCase(key) + '.' + kebabCase(value)
      };
    }, fieldData.items.enum);
  }

  return [];
}

function getInitialValue(fieldKey, initialValues, fieldData) {
  if (path([fieldKey], initialValues)) {
    return path([fieldKey], initialValues);
  }

  if (isTextField(fieldData)) {
    return '';
  }

  if (isCheckboxGroup(fieldData)) {
    return [];
  }

  if (isSelectField(fieldData)) {
    return head(defaultTo('', fieldData.enum));
  }

  return path(['const'], fieldData);
}

/**
 * Function which receive a child of uiSchema and returns a Component based on dataSchema.
 *
 * @private
 * @param {Object} child UI Schema
 * @param {Object} form form data
 * @param {Object} props.components Object that contains components
 * @param {Boolean} props.disabled Disables form fields if true
 * @param {Object} props.initialValues Initial values for form fields
 * @param {Function} props.getCustomField Function that returns custom field if it exists
 */

/* eslint-disable react/prop-types */
function getComponent(child, form, props) {
  var fieldData = path(tail(split('/', pathOr('', ['scope'], child))), form.dataSchema);
  if (!fieldData) {
    return null;
  }
  var key = last(split('/', child.scope));
  var options = getOptions(fieldData, form, key);
  var validators = getValidators(form.dataSchema, key);
  var placeholder = child.label ? child.label : '';
  var disabled = props.disabled || isToBeDisabled(child, form.fields);
  var format = path(['format'], fieldData);
  var initialValue = getInitialValue(key, props.initialValues, fieldData);
  var autoFocus = defaultTo(false, child.autoFocus);

  var Component = props.getCustomField(fieldData, key) || getField$1(fieldData, props.components);

  return React.createElement(Component, {
    id: key,
    name: key,
    options: options,
    validators: validators,
    format: format,
    placeholder: placeholder,
    keepOnUnmount: true,
    initialValue: initialValue,
    disabled: disabled,
    autoFocus: autoFocus
  });
}
/* eslint-enable react/prop-types */

function getEffects(schema) {
  var effect = pathOr(null, ['effect'], schema);
  var condition = pathOr(null, ['condition'], schema);

  if (effect || condition) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('"effect" and "condition" properties are deprecated, use "effects" property');
    }

    return [{ effect: effect, condition: condition }];
  }

  return pathOr([], ['effects'], schema);
}

function isToBeHidden(schema, formFields) {
  var result = reduce(function (result, rule) {
    if (rule.effect === 'show' || rule.effect === 'hide') {
      if (!rule.condition) {
        return rule.effect;
      }

      return validateCondition(rule, formFields) ? rule.effect : result;
    }

    return result;
  }, 'show', getEffects(schema));

  return result === 'hide';
}

function isToBeDisabled(schema, formFields) {
  var result = reduce(function (result, rule) {
    if (rule.effect === 'disable' || rule.effect === 'enable') {
      if (!rule.condition) {
        return rule.effect;
      }

      return validateCondition(rule, formFields) ? rule.effect : result;
    }

    return result;
  }, 'enable', getEffects(schema));

  return result === 'disable';
}

/**
 * Validates condition
 * @param {Object} rule UI schema rule
 * @param {Object} formFields Form data
 * @returns {boolean} Return true if schema validates to true and false otherwise.
 */
function validateCondition(rule) {
  var formFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var schema = path(['condition'], rule);

  var validate = validateSchema(schema, getValidatorValues(formFields));

  return validate.valid;
}

/**
 * @param {Object} dataSchema Data schema
 * @param {string} key Component identifier
 * @returns {Function[]} Array of validators
 */

function getValidators(dataSchema, key) {
  var fieldValidators = [];

  if (has('required', dataSchema) && dataSchema.required.includes(key)) {
    fieldValidators.push(required$1);
  }
  if (has('minimum', dataSchema) && key in dataSchema.minimum) {
    fieldValidators.push(min(dataSchema.minimum[key]));
  }
  if (has('maximum', dataSchema) && key in dataSchema.maximum) {
    fieldValidators.push(max(dataSchema.maximum[key]));
  }
  if (has('minLength', dataSchema) && key in dataSchema.minLength) {
    fieldValidators.push(minLength$1(dataSchema.minLength[key]));
  }
  if (has('maxLength', dataSchema) && key in dataSchema.maxLength) {
    fieldValidators.push(maxLength$1(dataSchema.maxLength[key]));
  }
  if (has('pattern', dataSchema) && key in dataSchema.pattern) {
    fieldValidators.push(matchesRegex(dataSchema.pattern[key]));
  }

  return fieldValidators;
}

/**
 * Get submit button
 *
 * @param {Object} components Components
 * @param {Object} form Form
 * @param {Object} uiSchema UI schema
 */

function getSubmitButton(components, form, uiSchema) {
  var isDisabled = !form.valid || isToBeDisabled(uiSchema, form.fields);
  return React.createElement(
    components.submit,
    { type: 'submit', disabled: isDisabled },
    uiSchema.content
  );
}

/**
 * Gets form fields from given schemas.
 *
 * @param {Object} uiSchema UI schema
 * @param {Object} props JSX attributes
 * @param {Object} props.components Components
 * @param {Function} props.getCustomField Getter for custom fields
 * @param {Object} form Form
 * @returns {Array.<Field>} Field components
 */

var mapIndex = addIndex(map);

function FieldBuilder(props) {
  var form = useContext(FormContext);
  var uiSchema = props.uiSchema.children ? merge(props.uiSchema, {
    children: mapIndex(function (child, index) {
      return assoc('$$KEY', index, child);
    }, props.uiSchema.children)
  }) : props.uiSchema;

  if (isToBeHidden(uiSchema, form.fields)) {
    return null;
  }

  var Text = props.components['text'];

  return React.createElement(
    React.Fragment,
    { key: uiSchema.$$KEY || uiSchema.id },
    uiSchema.type === 'Text' && React.createElement(
      Space,
      { all: 0 },
      React.createElement(
        Text,
        {
          size: uiSchema.size,
          weight: uiSchema.weight,
          color: uiSchema.color,
          align: uiSchema.align
        },
        uiSchema.translationKey
      )
    ),
    uiSchema.type === 'Control' && (has('grow', uiSchema) ? React.createElement(
      FlexItem,
      { grow: has('grow', uiSchema) ? uiSchema.grow : 0 },
      React.createElement(
        Space,
        { all: 0 },
        getComponent(uiSchema, form, props)
      )
    ) : React.createElement(
      Space,
      { all: 0 },
      getComponent(uiSchema, form, props)
    )),
    uiSchema.type === 'Submit' && getSubmitButton(props.components, form, uiSchema),
    uiSchema.type === 'Component' && React.createElement(props.components[uiSchema.id]),
    uiSchema.type === 'Row' && React.createElement(
      Flex,
      {
        wide: path(['wide'], uiSchema),
        wrap: path(['wrap'], uiSchema),
        grow: has('grow', uiSchema) ? uiSchema.grow : 0
      },
      map(function (child) {
        return React.createElement(FieldBuilder, _extends({ key: child.$$KEY }, props, { uiSchema: child }));
      }, uiSchema.children)
    ),
    uiSchema.type === 'Column' && React.createElement(
      Flex,
      {
        column: true,
        wide: path(['wide'], uiSchema),
        wrap: path(['wrap'], uiSchema),
        grow: has('grow', uiSchema) ? uiSchema.grow : 0
      },
      map(function (child) {
        return React.createElement(FieldBuilder, _extends({ key: child.$$KEY }, props, { uiSchema: child }));
      }, uiSchema.children)
    )
  );
}

FieldBuilder.defaultProps = {
  getCustomField: function getCustomField() {}
};

FieldBuilder.propTypes = {
  components: PropTypes.object,
  getCustomField: PropTypes.func,
  initialValues: PropTypes.object,
  uiSchema: PropTypes.object.isRequired
};

function FormBuilder(props) {
  return React.createElement(
    Form$1,
    {
      name: props.name,
      mountPoint: props.mountPoint,
      dataSchema: props.dataSchema,
      onSubmit: props.onSubmit
    },
    function () {
      return React.createElement(FieldBuilder, {
        disabled: props.disabled,
        components: props.components,
        getCustomField: props.getCustomField,
        initialValues: props.initialValues,
        uiSchema: props.uiSchema
      });
    }
  );
}

FormBuilder.propTypes = {
  components: PropTypes.object,
  dataSchema: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  getCustomField: PropTypes.func,
  initialValues: PropTypes.object,
  mountPoint: PropTypes.string.isRequired,
  name: PropTypes.string,
  uiSchema: PropTypes.object.isRequired,
  onSubmit: PropTypes.func
};

function normalizeTransactionAmount(withdrawalTransaction, moneyBalanceCents, maxAmount) {
  return function (value) {
    if (!value) {
      return undefined;
    }

    if (withdrawalTransaction) {
      if (moneyBalanceCents) {
        var maxWithdrawValue = moneyBalanceCents / 100;

        if (value > maxWithdrawValue) {
          return parseFloat(maxWithdrawValue);
        }

        return parseFloat(value);
      }

      return parseFloat(Math.min(value, maxAmount));
    }

    return parseFloat(Math.min(value, maxAmount));
  };
}

function normalizeExpiryYear(v) {
  if (!v) {
    return v;
  }

  var value = v.replace(/\s+/g, '').replace(/\D/gi, '');

  return '20' + takeLast(2, value);
}

function normalizeExpiryMonth(v) {
  if (!v) {
    return v;
  }

  var value = v.replace(/\s+/g, '').replace(/\D/gi, '');

  return takeLast(2, value);
}

function normalizeCreditCardNumber(value) {
  if (!value) {
    return value;
  }

  var segment = 4;
  var v = value.replace(/\s+/g, '').replace(/\D/gi, '');
  var matches = v.match(/\d{4,16}/g);
  var match = matches && matches[0] || '';
  var parts = [];

  for (var i = 0, len = match.length; i < len; i += segment) {
    parts.push(match.substring(i, i + segment));
  }

  if (parts.length) {
    return parts.join(' ');
  }

  return v;
}

var normalizers = {
  creditCard: normalizeCreditCardNumber,
  transactionAmount: normalizeTransactionAmount,
  expiryYear: normalizeExpiryYear,
  expiryMonth: normalizeExpiryMonth
};

function parseCreditCardNumber(value) {
  if (!value) {
    return value;
  }

  return value.match(/(\d{1,4})/g).join(' ');
}

function parseExpiryYear(v) {
  if (!v) {
    return v;
  }

  var value = v.replace(/\s+/g, '').replace(/\D/gi, '');

  if (value.length >= 2) {
    return value.length === 3 ? last(value) : takeLast(2, value);
  } else {
    return value;
  }
}

function parseExpiryMonth(v) {
  if (!v) {
    return v;
  }

  var value = v.replace(/\s+/g, '').replace(/\D/gi, '');

  if (value.length >= 2) {
    return takeLast(2, value);
  } else {
    return value;
  }
}

var parsers = {
  creditCard: parseCreditCardNumber,
  expiryYear: parseExpiryYear,
  expiryMonth: parseExpiryMonth
};

var initialState = {
  data: {},
  focused: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  var payload = action.payload;
  var fieldRegistered = isFieldRegistered(state, path(['form'], payload), path(['field'], payload));

  switch (action.type) {
    case BLURED:
      {
        return when(propEq('focused', payload), dissoc('focused'))(state);
      }
    case FIELDS_CLEARED:
      {
        return over(formFieldsLens(payload.form), mapObjIndexed(function (state, field) {
          if (contains(field, payload.fields)) {
            return resetField(state);
          }

          return state;
        }), state);
      }
    case FIELD_ERROR_RESET:
      {
        if (fieldRegistered) {
          return over(fieldLens(payload.form, payload.field), resetFieldErrors, state);
        } else {
          return state;
        }
      }
    case FOCUSED:
      {
        return assoc('focused', payload, state);
      }
    case FORM_CLEARED:
      {
        return over(formFieldsLens(payload), map(resetField), state);
      }
    case FORM_COMMITTED:
      {
        return over(formFieldsLens(payload), map(commitField), state);
      }
    case FIELD_DESTROYED:
      {
        if (fieldRegistered) {
          return over(formFieldsLens(payload.form), dissoc(payload.field), state);
        } else {
          return state;
        }
      }
    case FORM_DESTROYED:
      {
        return dissocPath(['data', payload], state);
      }
    case FORMS_DESTROYED:
      {
        return dissoc('data', state);
      }
    case FORM_VALIDATED:
      {
        return over(formLens(payload.form), pipe(assoc('status', payload.status), assoc('errors', payload.errors)), state);
      }
    case VALUE_CHANGED:
      {
        return over(fieldLens(payload.form, payload.field), pipe(assoc('value', payload.value), unless(prop('visited'), assoc('visited', true))))(state);
      }
    case REGISTERED:
      {
        return over(fieldLens(payload.form, payload.field), pipe(assoc('initialValue', payload.initialValue), assoc('value', payload.value || payload.initialValue), assoc('group', payload.group)))(state);
      }
    case VALIDATED:
      {
        if (fieldRegistered) {
          return over(fieldLens(payload.form, payload.field), pipe(assoc('status', payload.status), assoc('errors', payload.errors)))(state);
        } else {
          return state;
        }
      }
    case VISITED:
      {
        return over(fieldLens(payload.form, payload.field), assoc('visited', true))(state);
      }
    default:
      return state;
  }
}

export { connector$1 as Field, Form$1 as Form, FormContext, FormBuilder, FieldBuilder, normalizeTransactionAmount, normalizeExpiryYear, normalizeExpiryMonth, normalizeCreditCardNumber, normalizers, parseCreditCardNumber, parseExpiryYear, parseExpiryMonth, parsers, matchesRegex, length$1 as length, max, min, maxLength$1 as maxLength, minLength$1 as minLength, required$1 as required, reducer, blur, resetFieldErrors$1 as resetFieldErrors, clearFields, destroyField, clearForm, clearForms, commitForm, destroyForm, focus, validateForm$1 as validateForm, changeValue, register, validate$1 as validate, visit, BLURED, FIELDS_CLEARED, FIELD_ERROR_RESET, FIELD_DESTROYED, FOCUSED, FORM_CLEARED, FORM_COMMITTED, FORM_DESTROYED, FORM_VALIDATED, FORMS_DESTROYED, REGISTERED, VALIDATED, VALUE_CHANGED, VISITED, getForm, getField, getFormFields, getFormField, isFieldPristine, isAllFieldsHaveStatus, isFocused, isPristine, isValid, isVisited, errors, fields, formErrors, status, value$1 as value, isFieldRegistered };
